import * as firebase from 'firebase'
// Initialize Firebase
var config = {
  apiKey: "AIzaSyAuquA52bLqNlVEF7LCnEtpZZApT_aDQJA",
  authDomain: "indiary-60296.firebaseapp.com",
  databaseURL: "https://indiary-60296.firebaseio.com",
  projectId: "indiary-60296",
  storageBucket: "indiary-60296.appspot.com",
  messagingSenderId: "538754975866"
};

firebase.initializeApp(config);

export const database = firebase.database().ref('/notes')

export const auth = firebase.auth()
export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const twitterProvider = new firebase.auth.TwitterAuthProvider()



// WEBPACK FOOTER //
// ./src/firebase.js